import {createSelector} from '@reduxjs/toolkit'
import { 
    APPLICATION_STATUS_APPROVED_ISSUED, 
    APPLICATION_STATUS_DENIED,
    APPLICATION_STATUS_UNREAD, 
    APPLICATION_STATUS_WITHDRAWN_APPROVED, 
    APPLICATION_STATUS_WITHDRAWN_BY_CLIENT, 
    LICENCE_STATUS_NEW,
    LICENCE_STATUS_ACTIVE
} from '../../app/constants'
import { humanReadableDate, licenceSubTypeString, isBranchApplication } from '../../app/utils'

export function applicationData(applicationItem) { 
    return applicationItem?.businessLicenceData
}

const getRequestType = (qItem) => {
    switch(qItem.applicationStatus) {
        case APPLICATION_STATUS_WITHDRAWN_BY_CLIENT:
            return "Change to licence : Licence cancelled"
        default:
            return "Licence Application"
    }
}

const bltHomeSelector = createSelector(
    [state => state.bltComponents, 
    state => state.userAuth],
    ({bltHome}, {userData}) => {

        const userEmail = userData?.email 

        let queueHeaders = [
            { 
                key : "dateReceived",
                title : "Date received",
                sortBy: "SUBMITTED_DATE"
            },
            {
                key : "licencingSubTypeString",
                title : "Licence type",
                sortBy: "LICENCE_TYPE"
            },
            {
                key : "contactNameAndAgency",
                title : "Name & agency",
                sortBy: "NAME"
            }, 
            {
                key : "lastModified",
                title : "Last updated",
                sortBy: "DATE_MODIFIED"
            }, 
            {
                key : "applicationStatus",
                title : "Status",
                sortBy: "APPLICATION_STATUS"
            },
            {
                key : "review_button",
                title : ""
            }
        ]

        let queueItems = []
        
        if(bltHome.queue 
            && bltHome.queue
            && Array.isArray(bltHome.queue)
            && bltHome.queue.length > 0) 
        { 
            bltHome.queue.forEach(qItem => {

                let readOnly = false
                let appLockedBy = null
                if(qItem.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED
                    || qItem.applicationStatus === APPLICATION_STATUS_DENIED 
                    || qItem.applicationStatus === APPLICATION_STATUS_WITHDRAWN_APPROVED) 
                {
                    if(0 && qItem.businessApplicationHistoryData) { 
                        const change = qItem.businessApplicationHistoryData.find(c => !c.validated)
                        if(change) { 
                            readOnly = false
                        } else { 
                            readOnly = true
                        }
                    } else { 
                        readOnly = true
                    }
                    // readOnly = true
                } else if(qItem.applicationStatus !== APPLICATION_STATUS_WITHDRAWN_BY_CLIENT && qItem.locked && qItem.locked !== userEmail) { 
                    readOnly = true
                    appLockedBy = qItem.locked
                }

                const requestType = getRequestType(qItem);
                const contactName = qItem.contactName ?? ""  
                const businessName = qItem.name ?? "- - - -"

                let statusParam = qItem.applicationStatus ?? APPLICATION_STATUS_UNREAD

                if(qItem.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED
                    && (qItem.licenceStatus && qItem.licenceStatus !== LICENCE_STATUS_NEW)) {
                    statusParam =   qItem.licenceStatus
                }

                let considerRenewalName = true;
                if(qItem.licenceStatus === LICENCE_STATUS_ACTIVE) {
                    considerRenewalName = false;
                }

                const item = {
                    id : qItem.id,
                    licencingSubType : qItem.licencingSubType,
                    licencingSubTypeString : `${licenceSubTypeString(qItem.licencingSubType, considerRenewalName)}${isBranchApplication(qItem) ? ' - Branch' : ''}`,
                    requestType : requestType,
                    contactNameAndAgency : contactName + "," + businessName,
                    contactName : contactName,
                    businessName : businessName,
                    lastModified : humanReadableDate(qItem.modifiedDateTime),
                    dateReceived : humanReadableDate(qItem.submittedDate ? qItem.submittedDate : qItem.createdDateTime),
                    applicationStatus : statusParam,
                    licenceStatus: qItem.licenceStatus,
                    readOnly,
                    locked: appLockedBy
                }
                
                queueItems.push(item)
            });
        }

        return {
            ...bltHome,
            queueHeaders,
            queueItems
        }
    }
)

export const bltHomeSelect = state => ({ 
    bltHome : bltHomeSelector(state)
})
